import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { allowedNodeEnvironmentFlags } from "process";

export class CustomValidators {
    /** If no minimum date is supplied, defaults to January 1st, 1900 */
    static minDateValidator(date?: Date): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;

            if (!value) {
                return null;
            }

            const controlDate = new Date(control.value);

            if (!controlDate) {
                return null;
            }

            if (!date) {
                date = new Date('1900-01-01');
            }

            return controlDate >= date ? null : { dateTooFarGone: true };
        }
    }

    /** If no maximum date is provided, just uses the current date */
    static maxDateValidator(date?: Date): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;

            if (!value) {
                return null;
            }

            const controlDate = new Date(control.value);

            if (!controlDate) {
                return null;
            }

            if (!date) {
                date = new Date();
            }

            return controlDate <= date ? null : { maxDateExceeded: true };
        }
    }

    /** This requires a libRawDateValue directive to be placed on the input control of the date picker */
    static dateFormatValidator(allowEmpty: boolean = true): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const raw: string | undefined = (control as any)._rawValue;
            const strictISO = /^\d{4}-\d{2}-\d{2}$/;

            if (!raw) {
                return allowEmpty ? null : { invalidFormat: true };
            } else if (!strictISO.test(raw)) {
                return { invalidFormat: true };
            }

            const date = new Date(raw);
            if (date === null ||
                !date.getTime()) {
                return { invalidFormat: true }; 
            }

            return null;
        }
    }
}